var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLead = function SvgLead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.2 18.8",
    style: {
      enableBackground: "new 0 0 25.2 18.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M11.7,9L11,8.8l0.5-0.4c1.1-0.9,1.7-2.2,1.7-3.6c0-2.6-2.1-4.7-4.7-4.7C5.9,0,3.7,2.1,3.7,4.7 c0,1.4,0.6,2.7,1.7,3.6l0.5,0.4L5.3,9C2.2,10.2,0,13.1,0,15.9c0,0.8,0.3,2.2,2.6,2.7c0.9,0.2,2.1,0.2,3.7,0.2l2.3,0 c0.4,0,0.9,0,1.3,0l1.2,0c1.5,0,2.6,0,3.5-0.3c2.1-0.5,2.5-1.9,2.5-2.6C17,13.1,14.7,10.2,11.7,9z M4.9,4.7c0-2,1.6-3.6,3.6-3.6 c2,0,3.6,1.6,3.6,3.6c0,2-1.6,3.6-3.6,3.6C6.5,8.3,4.9,6.7,4.9,4.7z M11,17.6l-1.2,0c-0.4,0-0.9,0-1.3,0l-2.3,0c-2.4,0-5,0-5-1.7 c0-2.9,3.2-6.3,7.3-6.3c4.1,0,7.3,3.4,7.3,6.3C15.8,17.6,13.1,17.6,11,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CDD9E5",
    d: "M23.6,8.9c-0.4-0.4-0.8-0.7-1.3-1l-0.4-0.2l0.3-0.4c0.4-0.5,0.6-1.1,0.6-1.8c0-1.6-1.3-2.9-2.9-2.9 S17,4,17,5.6c0,0.6,0.2,1.2,0.6,1.7l0.3,0.4l-0.4,0.2C17.3,8,17.1,8.1,17,8.2c-0.1,0.1-0.2,0.2-0.2,0.4c0,0.2,0,0.3,0.1,0.4 c0.1,0.1,0.2,0.2,0.4,0.2c0.2,0,0.3,0,0.4-0.1c0.7-0.5,1.5-0.7,2.2-0.7c2.2,0,4,2,4.1,3.7l0,0.3l-0.3,0.1c-0.5,0.2-1.6,0.2-3,0.2 l-0.9,0c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6l1.7,0c1.7,0,2.7-0.1,3.2-0.7c0.2-0.2,0.4-0.6,0.4-0.9C25.2,11.2,24.6,9.9,23.6,8.9 z M19.9,7.3c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S20.9,7.3,19.9,7.3z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lead.550c785b.svg";
export { ForwardRef as ReactComponent };